import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiTool, FiMail } from 'react-icons/fi';
import { SidebarItem, MenuAccordionItem } from '../SidebarComponents';

const TestToolsMenu = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);
  const isAccordionActive = (parentPath) => location.pathname.startsWith(parentPath);

  return (
    <MenuAccordionItem
      icon={FiTool}
      label="Ferramentas de Teste"
      isActive={isAccordionActive('/emails/teste')}
      defaultIsOpen={isAccordionActive('/emails/teste')}
    >
      <SidebarItem
        icon={FiMail}
        label="Emails de Teste"
        to="/emails/teste"
        active={isActive('/emails/teste')}
        isSubmenuItem
      />
    </MenuAccordionItem>
  );
};

export default TestToolsMenu;
